import { render, staticRenderFns } from "./TabelaResultados.vue?vue&type=template&id=6235a4a9&scoped=true&"
import script from "./TabelaResultados.vue?vue&type=script&lang=js&"
export * from "./TabelaResultados.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultados.vue?vue&type=style&index=0&id=6235a4a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235a4a9",
  null
  
)

export default component.exports